import { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import { useI18n } from '../context/I18nContext';

function formatDuration(totalSeconds) {
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const parts = [];
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0 || days > 0) parts.push(`${hours.toString().padStart(2, '0')}h`);
  if (minutes > 0 || hours > 0 || days > 0) parts.push(`${minutes.toString().padStart(2, '0')}m`);
  parts.push(`${seconds.toString().padStart(2, '0')}s`);
  return parts.join(' ');
}

function AdminBanner({ config }) {
  if (!config?.trialBanner?.enabled || !config.trialBanner.message) return null;
  const { message, backgroundColor, textColor } = config.trialBanner;
  return (
    <div
      className="admin-trial-banner"
      style={{
        backgroundColor: backgroundColor || '#ef4444',
        color: textColor || '#ffffff'
      }}
    >
      <span dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  );
}

export default function TrialCountdown() {
  const { trialStatus, trialExpired, setShowPricing, appConfig, user } = useApp();
  const { t } = useI18n();
  const [now, setNow] = useState(Date.now());

  const isAdmin = user?.role === 'admin' || user?.role === 'superadmin';

  useEffect(() => {
    if (!trialStatus || trialStatus.expired) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [trialStatus]);

  const banner = appConfig?.trialBanner;
  const showAdminBanner = banner?.enabled && banner?.message && isAdmin && (
    (trialExpired && banner.showWhenExpired) ||
    (!trialExpired && trialStatus?.trialUser && banner.showWhenActive)
  );

  if (trialExpired) {
    return (
      <>
        {showAdminBanner && <AdminBanner config={appConfig} />}
        <div className="trial-expired-overlay">
          <div className="trial-expired-card">
            <div className="trial-expired-icon">⏰</div>
            <h2>{t('trialExpiredTitle')}</h2>
            <p>{t('trialExpiredText')}</p>
            <button className="btn-primary btn-large" onClick={() => setShowPricing(true)}>
              {t('trialExpiredCta')}
            </button>
          </div>
        </div>
      </>
    );
  }

  if (!trialStatus || !trialStatus.trialUser || trialStatus.expired) return null;

  const startedAt = new Date(trialStatus.trialStartedAt).getTime();
  const totalMs = trialStatus.trialDays * 24 * 60 * 60 * 1000;
  const remainingMs = Math.max(0, startedAt + totalMs - now);
  const remainingSeconds = Math.ceil(remainingMs / 1000);

  return (
    <>
      {showAdminBanner && <AdminBanner config={appConfig} />}
      <div className={`trial-countdown-banner ${showAdminBanner ? 'with-admin-banner' : ''}`}>
        <span className="trial-countdown-label">{t('remainingConnexionTime')}</span>
        <span className="trial-countdown-value">{formatDuration(remainingSeconds)}</span>
      </div>
    </>
  );
}
